import ArrowDown from "@components/Icons/ArrowDown";

const PromoMobileProductsFiltersToggle = ({ onClick, isActive }) => (
  <button
    className="flex justify-between items-center py-2 px-5 pr-[10px] border rounded-bl-lg rounded-tr-lg bg-white border-primary w-full h-[50px]"
    onClick={onClick}
  >
    Filtreaza
    <div className={isActive ? "rotate-180 mt-[6px]" : ""}>
      <ArrowDown />
    </div>
  </button>
);

export default PromoMobileProductsFiltersToggle;
